import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, X } from 'lucide-react';
export function FloatingToast() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Show after 5 seconds
    const showTimer = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    // Hide after 10 seconds of being shown
    const hideTimer = setTimeout(() => {
      setIsVisible(false);
    }, 15000);
    return () => {
      clearTimeout(showTimer);
      clearTimeout(hideTimer);
    };
  }, []);
  return <AnimatePresence data-id="element-139">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-4 left-4 md:bottom-8 md:left-8 z-50 bg-brand-card border border-brand-gold/30 rounded-xl p-4 shadow-2xl max-w-sm flex gap-4 items-start" data-id="element-140">
          <div className="bg-green-500/20 p-2 rounded-full shrink-0" data-id="element-141">
            <CheckCircle2 className="w-5 h-5 text-green-500" data-id="element-142" />
          </div>

          <div className="pr-6" data-id="element-143">
            <div className="text-xs text-gray-400 mb-1 flex items-center gap-1" data-id="element-144">
              Compra verificada
            </div>
            <p className="text-sm text-gray-200 leading-tight" data-id="element-145">
              <span className="font-bold text-white" data-id="element-146">
                Florencia B. de La Plata
              </span>{' '}
              compró Pack Completo + Método Chango Lleno 📚 hace 9 minutos
            </p>
          </div>

          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-500 hover:text-white" data-id="element-147">
            <X className="w-4 h-4" data-id="element-148" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}